var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDistIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 13.9998C5.125 13.9998 5.5 13.6248 5.5 13.1665V4.83317C5.5 4.37484 5.125 3.99984 4.66667 3.99984C4.20833 3.99984 3.83333 4.37484 3.83333 4.83317V13.1665C3.83333 13.6248 4.20833 13.9998 4.66667 13.9998ZM8 17.3332C8.45833 17.3332 8.83333 16.9582 8.83333 16.4998V1.49984C8.83333 1.0415 8.45833 0.666504 8 0.666504C7.54167 0.666504 7.16667 1.0415 7.16667 1.49984V16.4998C7.16667 16.9582 7.54167 17.3332 8 17.3332ZM1.33333 10.6665C1.79167 10.6665 2.16667 10.2915 2.16667 9.83317V8.1665C2.16667 7.70817 1.79167 7.33317 1.33333 7.33317C0.875 7.33317 0.5 7.70817 0.5 8.1665V9.83317C0.5 10.2915 0.875 10.6665 1.33333 10.6665ZM11.3333 13.9998C11.7917 13.9998 12.1667 13.6248 12.1667 13.1665V4.83317C12.1667 4.37484 11.7917 3.99984 11.3333 3.99984C10.875 3.99984 10.5 4.37484 10.5 4.83317V13.1665C10.5 13.6248 10.875 13.9998 11.3333 13.9998ZM13.8333 8.1665V9.83317C13.8333 10.2915 14.2083 10.6665 14.6667 10.6665C15.125 10.6665 15.5 10.2915 15.5 9.83317V8.1665C15.5 7.70817 15.125 7.33317 14.6667 7.33317C14.2083 7.33317 13.8333 7.70817 13.8333 8.1665Z",
    fill: "#3367CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistIcon);
export default __webpack_public_path__ + "static/media/distIcon.e899bc1d.svg";
export { ForwardRef as ReactComponent };